export enum UploadCSVStatus {
  PROCESSED = 0,
  PROCESSING = 1,
  CONCLUDED = 2,
  ERROR = 3,
}

export enum UploadStatus {
  ERROR = 1,
  SUCCESS = 2,
  REPROVED = 3,
}

export enum ServiceFeature {
  ALLOW_PAYMENT = 1,
}

export enum TransactionType {
  P2P = 1,
  TED = 2,
  BILLET = 3,
  RECHARGE_BILLET = 4,
  DEPOSIT = 5,
  PIX = 6,
  CASHBACK = 7,
  RECHARGE_CELLPHONE = 8,
  TARIFF = 9,
  ATM_WITHDRAW = 10,
  ATM_DEPOSIT = 11,
  CREDIT = 12,
  DEBIT = 13,
  CARD_DEBIT = 14,
  BALANCE_BLOCK = 15,
  BALANCE_UNLOCK = 16,
  PIX_BILLET = 17,
  PURCHASE_ORDER = 18,
  POINTS = 19,
  INVESTMENT_APPLICATION = 20,
  ACCOUNT_BALANCE = 21,
  TOTAL_AMOUNT = 22,
  PIX_WITHDRAW = 23,
  PIX_CHANGE = 24,
  QR_CODE = 25,
  MEMBER_GET_MEMBER_CASHBACK = 26,
  UNKNOWN = 100,
  API_GATEWAY_PIX = 306,
}

export enum FileAllowed {
  CSV = 'text/csv',
}

export enum ColumnIdentifier {
  BENEFICIARYS_TAX_IDENTIFIER = 'CPF/CNPJ_DO_BENEFICIARIO',
  TAX_IDENTIFIER = 'CPF/CNPJ',
  CNPJ = 'CNPJ',
  NAME = 'NOME',
  COMPANY_NAME = 'RAZAO_SOCIAL',
}

export enum EmployeesColumns {
  TAX_IDENTIFIER = 'TAX_IDENTIFIER',
  CNPJ = 'CNPJ',
}

export enum EmployeeCSVTab {
  PF = '1',
  PJ = '2',
}

export enum EmployeePaymentPageMode {
  APPROVE = 'approve',
  UPLOAD = 'upload',
}

export enum EmployeeAccountType {
  PF = 1,
  PJ = 2,
}
